import { getPublicCompressed } from '@toruslabs/eccrypto'
import axios from 'axios'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { ThreeDots } from 'react-loader-spinner'
import { useWeb3Auth } from '../../../services/web3auth'
import useAuthStore from '../../../store/authStore'
import useUploadStore from '../../../store/uploadStore'
import { truncateMiddle } from '../../../utils'

const MobileOverlay = ({
  currentCategory,
  currentQuery,
  setSearchCategory,
  parent,
  menu,
  openMenu,
}: any) => {
  const [searchBox, setSearchBox] = useState(false)
  const [loader, setLoader] = useState<boolean>(true)
  const [saltBalance, setSaltBalance] = useState<any>()
  const [maticBalance, setMaticBalance] = useState<any>()
  const [walletAddress, setWalletAddress] = useState<string>('')
  const [categoryOpen, setCategoryOpen] = useState<boolean>(false)
  const router = useRouter()
  const { setActiveStep, setCurrentCategory, setUploadAssetId } =
    useUploadStore()

  const [active, setActive] = useState('')

  const user_id = useAuthStore((state) => state.userInfo)

  // For getting user verified
  const [secretKey, setSecretKey] = useState<any>()
  const [idToken, setIdToken] = useState<any>()
  const [typeOfLogin, setTypeOfLogin] = useState<any>()

  const { getCategoryList, categoryList } = useUploadStore()
  const { setCurrentUser, setOpenLogginDetails } = useAuthStore()
  const { logout } = useWeb3Auth()

  const [category, setCategory] = useState('All Categories')
  let [userName, setUserName] = useState<string>('')
  let [userProfileImage, setUserProfileImage] = useState<string>('')
  // const [menu, setMenu] = useState(false)

  useEffect(() => {
    const path = router.route
    if (path === '/') setActive('discover')
    else setActive(path.slice(1).split('/')?.[0])
  }, [category, active, router])

  useEffect(() => {
    getCategoryList()
    if (walletAddress) return
    let x = setInterval(function () {
      setLoader(false)
    }, 4000)
    return () => clearInterval(x)
  }, [])

  const {
    provider,
    getAccounts,
    getMaticBalance,
    getPrivateKey,
    isLoading,
    metaMaskSign,
  } = useWeb3Auth()

  async function getCredentials() {
    setLoader(true)
    const wallet = await localStorage.getItem('WalletAddress')
    if (wallet !== null && wallet !== undefined) {
      setUserName(wallet)
      setLoader(false)
    }
    const crendetials = await localStorage.getItem('openlogin_store')
    if (crendetials !== null && crendetials !== undefined) {
      const user = JSON.parse(crendetials)
      setOpenLogginDetails(JSON.parse(crendetials))
      setIdToken(user.idToken)
      setTypeOfLogin(user.typeOfLogin)
    }
    setLoader(false)
  }

  useEffect(() => {
    if (provider) {
      if (
        !user_id ||
        user_id == undefined ||
        !walletAddress ||
        walletAddress == undefined
      )
        return
      const config = { user: { uid: user_id } }
      // console.log('config', config)
      axios
        .post(
          'https://us-central1-test-69192.cloudfunctions.net/userAuth/getWallet',
          config
        )
        .then((res) => {
          // const data = res?.data?.data?.data
          if (res?.data?.data?.salt) {
            setSaltBalance(res?.data?.data?.salt)
          } else {
            setSaltBalance(0)
          }
        })
        .catch((e) => {
          console.log(e)
        })

      Object.assign(config, { wallet_address: walletAddress })
      // console.log('Data is', config)
      if (typeOfLogin == 'jwt') {
        axios
          .post(
            'https://us-central1-test-69192.cloudfunctions.net/userAuth/updateWallet',
            config
          )
          .then((res) => console.log(res))
          .catch((e) => console.log(e?.response?.data?.message))
      }
    }
  }, [user_id, provider, walletAddress])

  useEffect(() => {
    if (provider) {
      getAccounts().then(() => {
        const address = localStorage.getItem('WalletAddress')
        if (address !== null && address !== undefined) {
          setWalletAddress(address)
          // console.log(walletAddress)
        }
      })
      if (walletAddress != '' && !isLoading && !loader) {
        getMaticBalance().then((data) =>
          setMaticBalance((data / 1e18).toFixed(2))
        )
      }

      const adapter = localStorage.getItem('Web3Auth-cachedAdapter')

      // TODO:
      if (adapter == 'wallet-connect-v1') {
        const walletConnect = localStorage.getItem('walletconnect')
        if (walletConnect !== null && walletConnect !== undefined) {
          // console.log('Hello there', walletConnect)
          // console.log('walletconnect login flow ')
          metaMaskSign()
            .then((data) => {
              const uid = data?.data?.data?.wallet?.address
              if (uid != undefined) {
                setCurrentUser(uid)
                localStorage.setItem('uid', uid)
              }
            })
            .catch((e) => {
              console.log(e)
            })

          localStorage.setItem('signature', '1')
        }
      }
      const isSigned = localStorage.getItem('signature')
      if (adapter == 'metamask' && isSigned == '0') {
        // console.log('metamask login flow ')
        metaMaskSign()
          .then((data) => {
            const uid = data?.data?.data?.wallet?.address

            if (uid != undefined) {
              setCurrentUser(uid)
              localStorage.setItem('uid', uid)
            }
          })
          .catch((e) => {
            // console.log(e)
          })

        localStorage.setItem('signature', '1')
      }

      if (typeOfLogin == 'discord') {
        // console.log('Only Discord Login goes here')
        // localStorage.setItem('uid', walletAddress)
        getPrivateKey().then((data) => {
          // console.log(data)
          setSecretKey(data)
        })

        let app_pub_key

        if (secretKey != undefined) {
          app_pub_key = getPublicCompressed(
            Buffer.from(secretKey.padStart(64, '0'), 'hex')
          ).toString('hex')
        }
        // console.log('secret key', secretKey)
        // console.log('app_pub_key', app_pub_key)

        const verifierData = {
          app_pub_key: app_pub_key,
          idToken: idToken,
          address: walletAddress,
          name: userName,
        }
        // console.log(verifierData)

        axios
          .post(
            'https://us-central1-test-69192.cloudfunctions.net/app/getverified-social',
            verifierData
          )
          .then((res) => {
            // console.log('response for discode', res)
            setCurrentUser(walletAddress)
            localStorage.setItem('uid', walletAddress)
          })
          .catch((e) => {
            // console.log(e)
          })
      }

      if (typeOfLogin == 'jwt' && localStorage.getItem('uid') === null) {
        const crendetials = localStorage.getItem('openlogin_store')
        if (crendetials !== null && crendetials !== undefined) {
          const user = JSON.parse(crendetials)
          // localStorage.setItem('uid', user.verifierId)
          const authToken = user.oAuthIdToken

          const config = {
            headers: {
              Authorization: `Bearer ${authToken}`,
            },
          }
          const body = {
            idToken: authToken,
          }
          // console.log(config)
          axios
            .post(
              'https://us-central1-test-69192.cloudfunctions.net/app/valid',
              body,
              config
            )
            .then(async (res) => {
              // console.log('response', res)
              // console.log('result', JSON.parse(res.data.data.token))
              const result = JSON.parse(res.data.data.token)
              setCurrentUser(result.uid)
              localStorage.setItem('uid', result.uid)
            })
            .catch((e) => {
              console.log('error occured', e)
            })
        }
      }

      if (!userName || !userProfileImage) {
        getCredentials()
      }
    }
  }, [userName, loader, getAccounts, provider, walletAddress])

  // const openMenu = (type: string) => {
  //   if (type === 'open') {
  //     setMenu(true)
  //     document.body.style.overflow = 'hidden'
  //   } else {
  //     setMenu(false)
  //     document.body.style.overflow = 'auto'
  //   }
  // }
  // console.log('mounted', menu)
  return (
    <div
      className={`${
        menu
          ? 'pointer-events-auto opacity-100'
          : 'pointer-events-none opacity-0'
      } visible absolute top-0 left-0 z-50 w-full border-primary bg-black/90 transition-all duration-300 ease-in md:hidden`}
      style={{ height: '200vh' }}
    >
      <div
        className={`ml-8 mt-8 flex w-10 -skew-x-12 transform items-center bg-white px-2 py-1 transition-all delay-100 duration-200 md:hidden`}
        onClick={() => openMenu('close')}
      >
        <Image
          src="/icons/close-red.svg"
          alt="menu"
          width={24}
          height={24}
          className="skew-x-12 transform brightness-200 grayscale invert"
        />
      </div>
      <div
        className={`${
          menu ? 'translate-x-0' : 'translate-x-12'
        } mt-10 ml-8 h-full w-full -skew-y-12 transform border-2 border-primary bg-black/40 pl-4 transition-all delay-100 duration-200`}
      >
        <span className="font-MonumentUltrabold text-7xl uppercase text-white opacity-10">
          MENU
        </span>
        <div className="mt-20 flex w-full skew-y-12 transform flex-col items-end justify-center">
          <a
            href="https://alter.game/whitepaper"
            target="_blank"
            rel="noreferrer"
            className="group inset-y-0 mb-4 mr-4 w-11/12 -skew-x-12 transform border-[#1A1A1A] bg-[#1A1A1A] py-6 text-center hover:cursor-pointer"
          >
            <div className="skew-x-12 transform text-white group-hover:text-primary">
              <span className="text-md font-MonumentRegular uppercase tracking-widest">
                Whitepaper
              </span>
            </div>
          </a>
          <div className="group inset-y-0 mb-4 mr-4 w-11/12 -skew-x-12 transform bg-[#1A1A1A] py-6 text-center hover:cursor-pointer">
            <div className="skew-x-12 transform text-primary">
              <span className="text-md font-MonumentRegular uppercase tracking-widest">
                shop
              </span>
            </div>
          </div>
          <div className="group inset-y-0 mb-4 mr-4 w-11/12 -skew-x-12 transform border-[#1A1A1A] bg-[#1A1A1A] py-6 text-center hover:cursor-pointer">
            <div className="skew-x-12 transform text-white group-hover:text-primary">
              <span className="text-md font-MonumentRegular uppercase tracking-widest">
                Map
              </span>
            </div>
          </div>
          <div className="group inset-y-0 mb-4 mr-4 w-11/12 -skew-x-12 transform border-[#1A1A1A] bg-[#1A1A1A] py-6 text-center hover:cursor-pointer">
            <div className="skew-x-12 transform text-white group-hover:text-primary">
              <span className="text-md font-MonumentRegular uppercase tracking-widest">
                Dive In
              </span>
            </div>
          </div>
          <>
            {loader ? (
              <div className="mr-4 flex w-11/12 -skew-x-12 transform items-center justify-center bg-primary py-6">
                <ThreeDots
                  color="black"
                  height={22}
                  width={40}
                  ariaLabel="loading-indicator"
                />
              </div>
            ) : walletAddress && provider ? (
              <Link href="/wallet">
                <button
                  id="userName_btn"
                  className="dropdown group relative mr-4 flex w-11/12 -skew-x-12 transform bg-yellow-300 px-6 py-6"
                  onClick={() => openMenu('close')}
                >
                  <Image
                    className="-ml-1 skew-x-12 rounded-full pl-1"
                    src={userProfileImage || '/images/auth/contacts_icon.svg'}
                    height={20}
                    width={20}
                    alt="Profile Image"
                  />
                  <p className="tranform text-md ml-2 skew-x-12 font-MonumentRegular uppercase">
                    {truncateMiddle(userName)}
                  </p>
                </button>
              </Link>
            ) : (
              <Link href="/login">
                <button
                  id="connect_btn"
                  className="mr-4 w-11/12 -skew-x-12 transform bg-yellow-300 py-6"
                  onClick={async () => {
                    localStorage.setItem('method', '1')
                    openMenu('close')
                  }}
                >
                  <div className="tranform text-md skew-x-12 font-MonumentRegular uppercase">
                    Connect
                  </div>
                </button>
              </Link>
            )}
          </>
          {provider ? (
            <div className=" mt-4 flex w-4/5 -skew-x-12 transform flex-row items-center justify-center border-2 border-green-700 bg-gray-800 py-4 text-white">
              <div className="flex skew-x-12 transform flex-row items-center justify-center">
                <Image
                  width={28}
                  height={24}
                  alt="salt"
                  src="/icons/salt.png"
                />
                <span className="font-spaceMonoregular mr-2 ml-2 text-sm">
                  {isNaN(saltBalance) ? '...' : saltBalance}
                </span>
              </div>
              <div className="flex skew-x-12 transform flex-row items-center justify-center">
                <Image
                  width={24}
                  height={24}
                  alt="matic"
                  src="/icons/polygon.png"
                />
                <span className="font-spaceMonoregular mr-2 ml-2 text-sm">
                  {isNaN(maticBalance) ? 0 : maticBalance}
                </span>
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  )
}

export default MobileOverlay
